import React from "react";
import { Box, Container } from "@mui/material";
import PropTypes from "prop-types";

// PageContainer wraps all page content with consistent padding and max width
const PageContainer = ({
  children,
  maxWidth = "lg",
  disablePadding = false,
}) => {
  return (
    <Box
      component="section" // Changed from main as App.js now has the main semantic element
      sx={{
        flexGrow: 1,
        // minHeight is removed as flexGrow on this and parent should handle it.
        // backgroundColor is removed as it's handled by App.js main style.
        py: disablePadding ? 0 : { xs: 2, sm: 3 }, // Adjusted padding with fixed values
        px: disablePadding ? 0 : { xs: 2, sm: 3 }, // Adjusted padding with fixed values
      }}
    >
      <Container
        maxWidth={maxWidth}
        disableGutters={disablePadding}
        sx={{
          height: "100%",
          animation: "fadeIn 0.5s ease-in-out",
          "@keyframes fadeIn": {
            "0%": { opacity: 0, transform: "translateY(10px)" },
            "100%": { opacity: 1, transform: "translateY(0)" },
          },
        }}
      >
        {children}
      </Container>
    </Box>
  );
};

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  disablePadding: PropTypes.bool,
};

export default PageContainer;
